import { render, staticRenderFns } from "./AndiamoPaiViewPage.vue?vue&type=template&id=086fca0c&scoped=true"
import script from "./AndiamoPaiViewPage.vue?vue&type=script&lang=js"
export * from "./AndiamoPaiViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086fca0c",
  null
  
)

export default component.exports